// src/components/ACCOUNT-PAGE/InformationsGenerales.jsx
import { FaCamera, FaSave } from "react-icons/fa"; // Icône disquette et caméra
import colors from "../../../../../styles/colors_global"; // Import des couleurs
import Input from "./Input";

export default function InformationsGenerales({ form, handleChange, handleSave, saving, hasChanged }) {
    return (
        <div className="space-y-6">
            {/* Photo de profil avec une couleur personnalisée */}
            <div className="flex items-center gap-6">
                <div
                    className="w-24 h-24 rounded-full flex items-center justify-center text-white font-bold text-2xl"
                    style={{ backgroundColor: colors.orange }} // Utilisation de la couleur orange
                >
                    {form.prenom?.[0] ?? "?"}
                    {form.nom?.[0] ?? "?"}
                </div>
                <div>
                    <button
                        className="flex items-center gap-2 text-sm font-medium border border-gray-300 px-4 py-2 rounded transition duration-300"
                        style={{
                            color: "white", // Texte blanc
                            backgroundColor: colors.lightGreen, // Couleur de fond initiale (vert)
                        }}
                        // Effet hover
                        onMouseEnter={(e) => e.target.style.backgroundColor = colors.green}
                        onMouseLeave={(e) => e.target.style.backgroundColor = colors.lightGreen}
                    >
                        <FaCamera className="text-lg" /> {/* Icône photo */}
                        Ajouter une photo de profil
                    </button>
                    <p className="text-xs text-gray-500 mt-2">
                        PNG, JPG, JPEG, BMP – 2MB max. La photo sera centrée.
                    </p>
                </div>
            </div>

            {/* Champs du formulaire avec titres stylisés */}
            <div className="space-y-5">
                <div className="space-y-2">
                    <label className="text-sm font-medium text-gray-700">Prénom</label>
                    <Input
                        value={form.prenom}
                        onChange={(e) => handleChange("prenom", e.target.value)}
                        className="border border-gray-300 rounded-md px-3 py-2 text-sm w-full focus:outline-none focus:ring-2 focus:ring-green-500"
                    />
                </div>
                <div className="space-y-2">
                    <label className="text-sm font-medium text-gray-700">Nom</label>
                    <Input
                        value={form.nom}
                        onChange={(e) => handleChange("nom", e.target.value)}
                        className="border border-gray-300 rounded-md px-3 py-2 text-sm w-full focus:outline-none focus:ring-2 focus:ring-green-500"
                    />
                </div>
                <div className="space-y-2">
                    <label className="text-sm font-medium text-gray-700">Adresse e-mail</label>
                    <Input
                        value={form.email}
                        onChange={(e) => handleChange("email", e.target.value)}
                        className="border border-gray-300 rounded-md px-3 py-2 text-sm w-full focus:outline-none focus:ring-2 focus:ring-green-500"
                    />
                </div>
                <div className="space-y-2">
                    <label className="text-sm font-medium text-gray-700">Téléphone</label>
                    <Input
                        value={form.telephone}
                        onChange={(e) => handleChange("telephone", e.target.value)}
                        className="border border-gray-300 rounded-md px-3 py-2 text-sm w-full focus:outline-none focus:ring-2 focus:ring-green-500"
                    />
                </div>
            </div>

            {/* Bouton d'enregistrement */}
            <div className="pt-4">
                <button
                    onClick={handleSave}
                    disabled={!hasChanged || saving}
                    className="w-full py-2 rounded text-sm flex items-center justify-center"
                    style={{
                        backgroundColor: hasChanged ? colors.green : colors.lightGreen, // Vert si modifié, sinon couleur claire
                        color: "white", // Texte toujours en blanc
                    }}
                >
                    <FaSave className="mr-2" /> {/* Icône disquette */}
                    {saving ? "Enregistrement..." : "Enregistrer"}
                </button>
            </div>
        </div>
    );
}